import { Component } from '@angular/core';

@Component({
  selector: 'app-termsandcondition',
  imports: [],
  templateUrl: './termsandcondition.component.html',
  styleUrl: './termsandcondition.component.scss'
})
export class TermsandconditionComponent {

}
